module.exports = __webpack_public_path__ + "img/znzy.48b3bd2f.png";